import React from "react";
import "./PaySlip.css";

const PaySlip = () => {
  return (
    <div className="Payloan-slip-container">
      <div className="Payloan-slip-card">
        {/* Header */}
        <div className="Payloan-slip-header">
          {/* Logo */}
          <div className="Paylogo-box">
            <img src="/logo.png" alt="logo" className="Paylogo" />
          </div>

          {/* Company Name + CIN + Address */}
          <div className="Paycompany-info">
            <h2>NIKHIL MICRO FINANCE PRIVATE LIMITED</h2>
            <span className="Paycin">CIN: <strong>U64910RJ2024PTC096767</strong></span>
            <span className="Payaddress"> Address :
              C/o Nanuram, shop At Vikas, Colony Ward 3, Hawada Mode, Srimadhopur, Sikar, Rajasthan, India, 332715
            </span>
          </div>

          {/* Mobile + Email */}
          <div className="Paycontact-info">
            <span><strong>Mobile No:</strong> 9667389854</span>
            <span className="payemail"><strong>Email ID:</strong>Nikhilmicrofinance@gmail.COM</span>
          </div>
        </div>

        {/* Customer Details */}
      <div className="Paysection">
  <h3>Customer Details</h3>
  <table className="Paysection-table">
    <tbody>
      <tr>
        <td><strong>Name:</strong> Riddhi Lambha</td>
        <td><strong>Aadhar:</strong> 35706886766</td>
      </tr>
      <tr>
        <td><strong>Guardian:</strong> Bharat Jat</td>
        <td><strong>PAN:</strong> HUPK2417Q</td>
      </tr>
      <tr>
        <td><strong>Mobile:</strong> 8432185085</td>
        <td><strong>Address:</strong> shrimadhopur</td>
      </tr>
    </tbody>
  </table>
</div>


       {/* Account Details */}
<div className="Paysection">
  <h3>Account Details</h3>
  <table className="Paysection-table">
    <tbody>
      <tr>
        <td><strong>Account Number:</strong> 001PL00001</td>
        <td><strong>Account Scheme:</strong> Personal Loan</td>
      </tr>
    </tbody>
  </table>
</div>

{/* Transaction Details */}
<div className="Paysection">
  <h3>Transaction Details</h3>
  <table className="Paysection-table">
    <tbody>
      <tr>
        <td><strong>Amount:</strong> Rs. 5361.00</td>
        <td><strong>Interest:</strong> 30%</td>
      </tr>
      <tr>
        <td><strong>Total Paid:</strong> Rs. 5361</td>
        <td><strong>Paid Date:</strong> 2024-10-24</td>
      </tr>
      <tr>
        <td><strong>Closure:</strong> Rs. 64341.53</td>
        <td><strong>Penalty Charges:</strong> Rs. 0.00</td>
      </tr>
    </tbody>
  </table>
</div>


        {/* Footer Paragraph */}
        <p className="Payfooter-text">
          This is a system-generated slip and does not require a signature.
        </p>

       {/* Signature Row */}
<div className="Paysignature-row">
  <div className="Paysignature-box">
    _______________________<br/>
    Authorized Signatory
  </div>
  <div className="Paysignature-box">
    
    _____________________
<br/>
    Customer Signature
  </div>
</div>


        {/* Print Button */}
        <button className="Payprint-btn" onClick={() => window.print()}>Print</button>
      </div>
    </div>
  );
};

export default PaySlip;
